/* eslint-disable jsdoc/check-param-names */
import { Dispatch, SetStateAction } from "react";
import { TextField } from "@mui/material";

type Props = {
  id: string;
  type: string;
  label: string;
  text: string;
  setText: Dispatch<SetStateAction<any>>;
  maxLength: number;
  variant?: "outlined" | "filled" | "standard"
  onChange?: Function;
  size?: "small" | "medium";
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  isNumericText?: boolean;
}

/**
 * カスタムテキストフィールド
 * @param id フィールドID
 * @param type タイプ
 * @param label ラベル
 * @param text テキスト
 * @param setText テキストをセット
 * @param maxLength 最大文字数
 * @param variant テキストフィールドの種類
 * @param size inputの大きさ
 * @param fullWidth 幅いっぱいにするかどうか
 * @param required 必須かどうか
 * @param disabled 非活性
 * @param isNumericText 半角数字のみのテキスト
 * @returns JSX.Element
 */
export default function CustomTextField({
  id,
  type,
  label,
  text,
  setText,
  maxLength,
  variant = 'outlined',
  onChange = () => {},
  size = 'medium',
  fullWidth,
  required,
  disabled,
  isNumericText
}: Props) {
  const onChangeText = (value: string) => {
    if (isNumericText && !(/^\d*$/.test(value))) {
      // 数値テキストで数値以外の文字が入力されたら無視
      return;
    }
    setText(value);
    onChange();
  }
  return (
    <TextField id={id} type={type} value={text}
      label={label}
      inputProps={{
        maxLength,
      }}
      variant={variant}
      onChange={(e) => onChangeText(e.target.value)}
      size={size}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      sx={{maxWidth: 223}}
    />
  );
}